module.exports = {"654301001":"金山路","654301002":"解放路","654301003":"团结路","654301004":"恰秀路街道","654301100":"北屯镇","654301101":"阿苇滩镇","654301102":"红墩镇","654301103":"切木尔切克镇","654301104":"阿拉哈克镇","654301202":"汗德尕特蒙古族乡","654301203":"拉斯特乡","654301204":"喀拉希力克乡","654301205":"萨尔胡松乡","654301206":"巴里巴盖乡","654301207":"切尔克齐乡","654301400":"喀拉尕什牧场","654301401":"阿克吐木斯克牧场","654301500":"兵团一八一团"}


//////////////////
// WEBPACK FOOTER
// ./src/town/654301.json
// module id = 3143
// module chunks = 0